import { useEffect, useState } from 'react';

import { useFileDetails } from './api/getFileDetails';

import { mapFileEntry } from '../../../models/FileEntry';

type useMappedFileEntryProps = {
  fileId: number;
};

export const useMappedFileEntry = ({ fileId }: useMappedFileEntryProps) => {
  const fileDetailsMutation = useFileDetails({
    fileId,
  });
  const [mappedFileEntry, setMappedFileEntry] = useState(null);

  useEffect(() => {
    if (!fileDetailsMutation.data) {
      return;
    }

    if (!fileDetailsMutation.data?.data) {
      return;
    }

    setMappedFileEntry(mapFileEntry(fileDetailsMutation.data.data));
  }, [fileDetailsMutation.data]);

  return {
    mappedFileEntry,
    isLoading: fileDetailsMutation.isLoading,
    fileDetailsQueryData: fileDetailsMutation.data,
    fileDetailsMutation: fileDetailsMutation,
  };
};
